export default __webpack_public_path__ + "static/Alice-Regular-6676c30016104188a3ec561e35837cc1.ttf";